import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVonageComponent } from './simple-icons-vonage.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVonageComponent ],
    exports:      [ SimpleIconsVonageComponent ],
    bootstrap:    []
})
export class SimpleIconsVonageModule {}
